import { Box, Divider, Typography } from "@mui/material"
import type { FC, ReactNode } from "react"

interface PreferenceTwoColumnRowProps {
  leftContent: ReactNode
  rightContent: ReactNode
  badge?: ReactNode
  shouldShowDivider?: boolean
  testId?: string
  isHeader?: boolean
}

export const PreferenceTwoColumnRow: FC<PreferenceTwoColumnRowProps> = ({
  leftContent,
  rightContent,
  badge,
  shouldShowDivider = false,
  testId,
  isHeader = false,
}) => {
  const textClassName = isHeader ? "text-base font-medium text-gray-900" : "text-gray-900"

  return (
    <>
      <Box className='flex gap-4 py-4' data-test={testId}>
        <Box className='flex min-w-0 flex-1 items-center gap-3'>
          <Typography variant='body2' className={`truncate ${textClassName}`}>
            {leftContent}
          </Typography>
          {badge}
        </Box>
        <Box className='flex min-w-0 flex-1 items-center'>
          <Typography variant='body2' className={textClassName}>
            {rightContent}
          </Typography>
        </Box>
      </Box>
      {shouldShowDivider && <Divider />}
    </>
  )
}
